<template>
  <div class="eachMonth">
    <div class="monthtitle">{{month}}</div>
    <div class="dates">
      <div class="t" v-for="w in ['一', '二', '三', '四', '五', '六', '日']" :key="w">{{w}}</div>
      <div v-for="b in datebefore" :key="`b-${b}`"></div>
      <slot v-for="d in dates" :d="d"/>
      <div v-for="a in dateafter" :key="`a-${a}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['start'],
  computed: {
    month () {
      return this.moment(this.start).format('Y年 M月')
    },
    datebefore () {
      const d = (this.moment(this.start).weekday() || 0) - 1
      return d === -1 ? 6 : d
    },
    dateafter () {
      return 7 - (this.moment(this.start).endOf('month').weekday() || 7)
    },
    dates () {
      const diff = this.moment(this.start).add(1, 'month').diff(this.moment(this.start), 'day')
      console.log('diff', diff, this.month)
      return Array(diff).fill('1').map((e, d) => {
        return {
          f: this.moment(this.start).add(d, 'day').format('YYYY-MM-DD'),
          d: this.moment(this.start).add(d, 'day').format('D')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.eachMonth {
  border: 1px solid #CACACA;
  border-radius: 3px;
  max-width: 400px;
}
.monthtitle {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: .2em;
  background-color: var(--color-checked);
  color: #FFFFFF;
}
.dates {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(7, 1fr);
  min-height: 280px;
  &>div{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.dates>:not(.t) {
  width: 40px;
  height: 40px;
}
</style>
